import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseTable from '../../components/shared/table/BaseTable';
import AuctionListToolbar from './AuctionListToolbar';
import { useColumns } from './hooks/useColumns';
import { TableContext } from '../../components/shared/table/context/TableContext';
import AuctionCard from './AuctionCard';
import { useMediaQuery } from '../../hooks/useMediaQuery';

export function AuctionListTable({
  data = [],
  loading = false,
  error = null
}) {
  const navigate = useNavigate();
  const columns = useColumns();
  const { setColumns, filterRows } = useContext(TableContext);
  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    setColumns(columns);
  }, [columns, setColumns]);

  // Add sort values
  const processedData = data.map(row => {
    const status = (row.system_auction_status || row.status || '').toLowerCase();
    const order = {
      'active': 1,
      'upcoming': 2,
      'pending': 3,
      'completed': 4,
      'cancelled': 5,
      'hidden': 6
    };
    return {
      ...row,
      _sort_status: order[status] || 7
    };
  });

  return (
    <div className="flex flex-col h-full min-h-0">
      <AuctionListToolbar
        columns={columns}
        data={data}
        showQuickFilter={true}
        quickFilterProps={{ debounceMs: 300 }}
      />
      {isMobile ? (
        <div className="p-4 space-y-4 bg-gray-50 overflow-y-auto">
          {filterRows(processedData).map(auction => (
            <AuctionCard
              key={auction.id}
              auction={auction}
            />
          ))}
        </div>
      ) : (
        <BaseTable
          data={processedData}
          columns={columns}
          loading={loading}
          error={error}
          onRowClick={(id, button) => {
            if (id) {
              // Check if this is a system auction by looking for the prefix
              const isSystemAuction = id.toString().startsWith('system_');
              const path = isSystemAuction ?
                `/auctions/system/${id.replace('system_', '')}` :
                `/auctions/${id}`;

              if (button === 0) { // Left click
                navigate(path);
              } else if (button === 1) { // Middle click
                window.open(path, '_blank');
              }
            }
          }}
        />
      )}
    </div>
  );
}
